export default "__VITE_ASSET__CjJwhfcP__"